<template>
  <div class="home-wrap">
    <div class="padding-11-15 padding-b-0 flex-div">
      <div class="title-text-official padding-b-19">公众号授权</div>
      <div class="switch-btn" @click="SwitchPublic">切换公众号</div>
    </div>
    <div class="auth-box padding-11-15 padding-b-0" v-if="authStep == 1">
      <img src="../../../../assets/img/h5/official/accredit_prompt_bg.png">
      <div class="auth-info">
        <div class="auth-title">授权说明</div>
        <div class="auth-content">
          <div class="auth-content-item">授权过程需要该公众号的管理员扫码，管理员一般是注册公众号的人，运营者是不能授权的。</div>
          <div class="auth-content-item">如果你是公众号的管理员，点击下方按钮，扫码授权即可。</div>
          <div class="auth-content-item">如果你是公众号的运营者，点击下方按钮，在授权二维码出来后，把二维码截图发给管理员，授权过程中请不要关闭当前页面，等对方扫码通过后，这边就可以授权成功了。</div>
        </div>
      </div>
      <div class="auth-btn"><a :href="authLink" target="_blank">点击开始授权公众号</a></div>
    </div>
    <div class="auth-detail" v-if="authStep == 2">
      <div class="detail-wrap padding-0-15">
        <div class="detail-div">
          <img v-if="headImg" :src="headImg" alt="">
          <img v-else src="../../../../assets/img/official/weishouquan.png" alt="">
          <div class="wechat-title">{{platformName}}</div>
        </div>
        <div class="operate-div">
          <div class="wechat-btn"><span @click="syncTemplate()">同步消息模板</span></div>
          <div class="wechat-btn"><span @click="bindWechatAdmin()">绑定微信管理员</span></div>
        </div>
        <div class="link-div">
          <div class="link-title">
            您的影票专属推广链接为：
          </div>
          <div class="link">
            <a target="_blank" :href="promotionLink">{{promotionLink}}</a>
          </div>
          <div v-show="!isBasic">
            <div class="link-title">
              其他页面链接：
            </div>
            <div class="link" >
              <div class="link-info"><label>个人中心：</label><a target="_blank" :href="personalLink">{{personalLink}}</a></div>
              <div class="link-copy-btn" @click="copyLink(personalLink)">复制链接</div>
            </div>
            <div class="link">
              <div class="link-info"><label>邀请好友：</label><a target="_blank" :href="posterLink">{{posterLink}}</a></div>
              <div class="link-copy-btn" @click="copyLink(personalLink)">复制链接</div>
            </div>
          </div>
          <div class="link-tip">
            将链接放于您的公众号菜单栏中，会员点击菜单就可以专属购票页面，订单结算后您将获得订单利润分佣。
          </div>
        </div>
      </div>
      <div class="gray"></div>
      <div class="notice-wrap padding-11-15 padding-b-0">
        <div class="auth-title">注意事项</div>
        <div class="auth-content">
          <div class="auth-content-item">1、授权成功后，请先 <span @click="syncTemplate()">同步消息模版</span></div>
          <div class="auth-content-item">2、不要手动去删除微信公众号生成的消息模板</div>
          <div class="auth-content-item">3、有任何出券码的问题，及时联系客服处理</div>
        </div>
        <div class="qrcode-box">
          <div class="qrcode-div margin-right-10">
            <img class="qrcode-img" src="../../../../assets/img/official/service1.jpg" alt="">
            <div class="nickname">守兔票务-雪糕</div>
          </div>
          <div class="qrcode-div margin-left-10">
            <img class="qrcode-img" src="../../../../assets/img/official/service2.jpg" alt="">
            <div class="nickname">守兔票务-婷欧尼</div>
          </div>
        </div>
      </div>
    </div>
    <sync-template ref="template"></sync-template>
    <admin ref="admin"></admin>
    <switch-public ref="SwitchPublic"></switch-public>
  </div>
</template>

<script>
import SyncTemplate from '@/views/h5/official/authorization/modal/SyncTemplate.vue'
import Admin from '@/views/h5/official/authorization/modal/Admin.vue'
import SwitchPublic from '@/views/h5/official/authorization/modal/SwitchPublic.vue'
import { getUserUUID, getNickname, getPlatformUuid, getPlatformName, getHeadImg, getIsAuthOfficial, getSnaphotId, getIsBasic} from '@/utils/auth'
import official from '@/javaApi/official'
const officialModel = new official()
export default {
  name: 'Authorization',
  components: {
    SyncTemplate,
    Admin,
    SwitchPublic
  },
  data: function () {
    return {
      isBasic: getIsBasic() === 'true' ? true : false, //是否是基础版本
      listLoading: false,
      userUUID : getUserUUID(),
      bindPackage: [],
      publicInfo: [],
      authLink: process.env.VUE_APP_MOVIE_DOMAIN + 'movie/api/dis.distribution/toauth?openUserName=' + getNickname() + '&openUserUuid=' + getUserUUID() + '&snapshotId='+ getSnaphotId(),
      promotionLink:  process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=1',
      personalLink:  process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=personal',  //个人中心链接
      posterLink:  process.env.VUE_APP_MOVIE_PROMOTION_URL + 'yp-api/movie/wx/pub-login?platformUuid=' + getPlatformUuid() + '&type=poster',      //邀请好友链接
      authStep: getIsAuthOfficial() === 'true' ? 2 : 1,
      headImg: getHeadImg(),
      platformName: getPlatformName()
    }
  },
  methods: {
    syncTemplate: function () {
      this.$refs.template.init();
      //https://test.taototo.cn/movie/api/template/addOneTemplate?platformUUID=xxxx
      console.log('同步消息模板')
    },
    bindWechatAdmin: function () {
      this.$refs.admin.init()
      //https://test.taototo.cn/movie/api/dis.user/bindAdmin?adminPlatform=XXXX ---这个是绑定微信管理员 - 扫码绑定（获取二维码链接）
      console.log('绑定微信管理员')
    },
    // 切换公众号
    SwitchPublic: function (){
      this.$refs.SwitchPublic.init()
    },
    copyLink: function (link) {
      var that = this
      this.$copyText(link).then(function (e) {
        that.$Message.success('复制成功')
        console.log(e)
      }, function (e) {
        that.$Message.error('复制失败,请升级浏览器版本！')
        console.log(e)
      })
    },

  }
}
</script>

<style lang="less" scoped>
.home-wrap{
  font-family: Alibaba-PuHuiTi-R;
  .flex-div{
    display: flex;
    justify-content: space-between;
    .switch-btn{
      background: #FF8622;
      border-radius: 28px;
      font-size: 12px;
      color: #FFFFFF;
      width: 99px;
      height: 28px;
      line-height: 28px;
      text-align: center;
    }
  }
  .auth-title{
    font-family: Alibaba-PuHuiTi-M;
    font-size: 16px;
    color: #222222;
    margin-bottom: 11px;
  }
  .auth-content{
    text-align: left;
    .auth-content-item{
      font-size: 12px;
      color: #666666;
      margin-bottom: 10px;
      line-height: 17px;
    }
  }
  .auth-box{
    text-align: center;
    img{
      padding: 30px 0 36px;
      width: 160px;
      text-align: center;
    }
    .auth-btn{
      margin: 18px 0;
      width: 100%;
      background: #FF8622;
      border-radius: 20px;
      font-size: 16px;
      color: #FFFFFF;
      padding: 9px 0;
      text-align: center;
      a,a:hover,a:visited,a:link,a:focus{
        color: #FFFFFF;
      }
    }
  }
  .auth-detail{
    .detail-wrap{
      margin-bottom: 20px;
      .detail-div{
        margin-top: 7px;
        display: flex;
        align-items: flex-end;
        img{
          width: 70px;
          margin-right: 8px;
        }
        .wechat-title{
          font-size: 16px;
          color: #666666;
        }
      }
      .operate-div{
        margin-top: 15px;
        margin-bottom: 10px;
        display: flex;
        .wechat-btn{
          margin-right: 10px;
          background: #FFFFFF;
          border: 1px solid #FF8622;
          border-radius: 1px;
          padding:6px 10px;
          font-size: 12px;
          color: #FF8622;
        }
      }
      .link-div{
        margin-top: 20px;
        .link-title{
          font-size: 14px;
          color: #222222;
          margin-top: 15px;
        }
        .link-title:first-child{
          margin-top: 0;
        }
        .link{
          .link-info{
            display: flex;
            margin-top: 10px;
            label{
              white-space: nowrap;
            }
          }
          a,a:hover,a:visited,a:link,a:focus{
            font-size: 12px;
            color: #3D9EFC;
            line-height: 17px;
            overflow-wrap: break-word;
            word-break: break-word;
            word-wrap: break-word;
          }
          .link-copy-btn{
            background: #FFFFFF;
            border: 1px solid #FF8622;
            border-radius: 1px;
            font-size: 12px;
            color: #FF8622;
            padding: 6px 0;
            width: 90px;
            text-align: center;
            margin: 10px auto 15px;
          }
        }
        .link-tip{
          font-size: 12px;
          color: #666666;
        }
      }
    }
    .notice-wrap{
      .auth-content .auth-content-item{
        margin-bottom: 5px;
        span{
          color: #FF4F76;
          cursor: pointer;
        }
      }
      .qrcode-box{
        display: flex;
        padding-top: 5px;
        padding-bottom: 59px;
        .qrcode-div{
          padding: 10px;
          margin-right: 15px;
          background: #FFFFFF;
          border: 1px solid #EEEEEE;
          border-radius: 2px;
          .qrcode-img{
            width: 90px;
            height: 90px;
            margin-bottom: 5px;
            object-fit: contain;
          }
          .nickname{
            font-size: 12px;
            color: #222222;
            text-align: center;
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/h5/official/authorization/Index.vue